import React from "react";
import { Grid } from "@mui/material";

const TabPanel = ({ children, value, index, ...other }) => (
  <Grid
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && children}
  </Grid>
);

export default TabPanel;
